const SubmitStoryOffer = () => (
  <svg
    width="386"
    height="274"
    viewBox="0 0 386 274"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="3804"
      height="1317"
      transform="translate(-1283 -325)"
      fill="white"
    />
    <path
      d="M328.887 55.1116L330.887 55.1302V55.1302L328.887 55.1116ZM328.702 75.088L326.702 75.0694L326.702 75.0787V75.088H328.702ZM39 203C39 204.105 39.8954 205 41 205C42.1046 205 43 204.105 43 203H39ZM43 218C43 216.895 42.1046 216 41 216C39.8954 216 39 216.895 39 218H43ZM53 45H316.888V41H53V45ZM326.887 55.093L326.702 75.0694L330.702 75.1066L330.887 55.1302L326.887 55.093ZM43 203V55H39V203H43ZM43 241.5V218H39V241.5H43ZM326.702 75.088V241.5H330.702V75.088H326.702ZM316.888 45C322.447 45 326.939 49.534 326.887 55.093L330.887 55.1302C330.96 47.3476 324.671 41 316.888 41V45ZM53 41C45.268 41 39 47.268 39 55H43C43 49.4772 47.4772 45 53 45V41Z"
      fill="#0C393F"
    />
    <path
      d="M133 244C134.105 244 135 243.105 135 242C135 240.895 134.105 240 133 240V244ZM149 240C147.895 240 147 240.895 147 242C147 243.105 147.895 244 149 244V240ZM326 270H38V274H326V270ZM18 250V248H14V250H18ZM346 248V250H350V248H346ZM22 244H133V240H22V244ZM149 244H342V240H149V244ZM350 248C350 243.582 346.418 240 342 240V244C344.209 244 346 245.791 346 248H350ZM38 270C26.9543 270 18 261.046 18 250H14C14 263.255 24.7452 274 38 274V270ZM326 274C339.255 274 350 263.255 350 250H346C346 261.046 337.046 270 326 270V274ZM18 248C18 245.791 19.7909 244 22 244V240C17.5817 240 14 243.582 14 248H18Z"
      fill="#0C393F"
    />
    <rect x="163" y="55" width="40" height="4" rx="2" fill="#0C393F" />
    <rect
      x="67"
      y="72"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="148.531"
      y="72"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="230.061"
      y="72"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="72.8369"
      y="133.388"
      width="68.1441"
      height="43.6122"
      rx="10.9031"
      fill="#FEC077"
    />
    <rect
      x="67"
      y="128.592"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="153.989"
      y="133.388"
      width="68.1441"
      height="43.6122"
      rx="10.9031"
      fill="#FEC077"
    />
    <rect
      x="148.531"
      y="128.592"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="230.061"
      y="128.592"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="67"
      y="185.184"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="148.531"
      y="185.184"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <rect
      x="230.061"
      y="185.184"
      width="67.9388"
      height="42.0408"
      rx="9.5102"
      stroke="#0C393F"
      strokeWidth="4"
    />
    <path
      d="M199.579 157.392C197.093 157.392 194.799 155.89 193.585 154.994V152.451C194.827 153.372 196.409 154.301 198.18 154.66L199.661 154.961L200.267 152.025L198.786 151.725C196.617 151.285 194.652 149.502 193.595 148.544C193.591 148.54 193.588 148.537 193.584 148.533V146.262C194.484 146.94 195.563 147.59 196.771 147.951L198.219 148.383L199.092 145.514L197.645 145.081C195.991 144.587 194.523 143.169 193.645 142.322C193.623 142.301 193.605 142.283 193.584 142.263V140.03C193.936 140.3 194.316 140.572 194.723 140.833L195.993 141.646L197.634 139.13L196.364 138.317C195.266 137.614 194.336 136.752 193.72 136.182C193.405 135.89 193.177 135.679 192.972 135.525C192.433 135.124 191.692 135.124 191.155 135.525C190.942 135.683 190.71 135.902 190.39 136.206C189.782 136.781 188.862 137.65 187.782 138.341L186.512 139.154L188.153 141.67L189.423 140.857C189.829 140.597 190.209 140.324 190.561 140.05V142.085C190.479 142.164 190.393 142.248 190.297 142.342C189.456 143.166 188.051 144.547 186.476 145.046L185.036 145.503L185.957 148.356L187.398 147.899C188.603 147.517 189.675 146.839 190.561 146.145V148.364C190.493 148.425 190.421 148.492 190.344 148.563C189.323 149.5 187.423 151.244 185.333 151.708L183.857 152.035L184.517 154.959L185.993 154.632C187.763 154.24 189.342 153.267 190.561 152.332V154.809C189.476 155.638 187.098 157.34 184.513 157.386H184.489C181.621 157.377 179.009 155.373 178.026 154.619C177.933 154.548 177.853 154.486 177.787 154.437C177.249 154.036 176.508 154.036 175.97 154.437C175.899 154.49 175.812 154.557 175.71 154.636C174.751 155.376 172.203 157.343 169.418 157.382L167.906 157.403L167.948 160.398L169.46 160.377C172.669 160.332 175.4 158.602 176.881 157.518C178.398 158.62 181.192 160.371 184.483 160.382H184.526C184.534 160.382 184.542 160.382 184.551 160.382C187.75 160.33 190.473 158.605 191.95 157.523C193.473 158.63 196.278 160.386 199.577 160.386H201.089V157.39H199.579V157.392Z"
      fill="#0C393F"
    />
    <path
      d="M112.019 157.392C109.534 157.392 107.24 155.89 106.026 154.994V152.451C107.268 153.372 108.85 154.301 110.62 154.66L112.102 154.961L112.708 152.025L111.227 151.725C109.058 151.285 107.093 149.502 106.036 148.544C106.032 148.54 106.028 148.537 106.025 148.533V146.262C106.925 146.94 108.004 147.59 109.212 147.951L110.66 148.383L111.533 145.514L110.086 145.081C108.432 144.587 106.964 143.169 106.086 142.322C106.064 142.301 106.046 142.283 106.025 142.263V140.03C106.377 140.3 106.757 140.572 107.164 140.833L108.433 141.646L110.074 139.13L108.804 138.317C107.707 137.614 106.777 136.752 106.161 136.182C105.846 135.89 105.618 135.679 105.413 135.525C104.874 135.124 104.133 135.124 103.596 135.525C103.383 135.683 103.151 135.902 102.831 136.206C102.222 136.781 101.303 137.65 100.223 138.341L98.9529 139.154L100.594 141.67L101.864 140.857C102.27 140.597 102.65 140.324 103.002 140.05V142.085C102.92 142.164 102.834 142.248 102.738 142.342C101.897 143.166 100.492 144.547 98.9166 145.046L97.4764 145.503L98.3983 148.356L99.8384 147.899C101.044 147.517 102.116 146.839 103.002 146.145V148.364C102.934 148.425 102.862 148.492 102.785 148.563C101.764 149.5 99.8643 151.244 97.7738 151.708L96.2983 152.035L96.9581 154.959L98.4337 154.632C100.204 154.24 101.783 153.267 103.002 152.332V154.809C101.916 155.638 99.5391 157.34 96.9543 157.386H96.9295C94.0616 157.377 91.45 155.373 90.4669 154.619C90.3742 154.548 90.2939 154.486 90.2279 154.437C89.6895 154.036 88.9493 154.036 88.411 154.437C88.3402 154.49 88.2532 154.557 88.1508 154.636C87.1917 155.376 84.6442 157.343 81.8586 157.382L80.3467 157.403L80.3888 160.398L81.9006 160.377C85.1099 160.332 87.841 158.602 89.3223 157.518C90.8389 158.62 93.6332 160.371 96.9237 160.382H96.9668C96.9754 160.382 96.983 160.382 96.9916 160.382C100.191 160.33 102.914 158.605 104.391 157.523C105.914 158.63 108.718 160.386 112.018 160.386H113.529V157.39H112.019V157.392Z"
      fill="#0C393F"
    />
    <rect x="243" y="270" width="120" height="4" rx="2" fill="#0C393F" />
    <rect x="370" y="270" width="16" height="4" rx="2" fill="#0C393F" />
    <rect y="270" width="60" height="4" rx="2" fill="#0C393F" />
  </svg>
)

export default SubmitStoryOffer
